import React from 'react';
import Modal from 'react-bootstrap/lib/Modal';
import LocalStorage from '~/services/LocalStorage';
import Config from '~/config';

function JapanSiteNoticePremium({ onApproval, onClose }) {
  const reject = () => {
    LocalStorage.hideJapanNoticePremium = false;
    onClose();
  };

  const approval = () => {
    LocalStorage.hideJapanNoticePremium = true;
    onApproval();
  };

  return (
    <Modal show>
      <Modal.Body>
        <div className="text-survey">
          このwebサイトは、海外版のイラストAC/写真ACサイトです。
          プレミアム会員登録を行なった場合、海外版サイトのみで有効となり、日本版サイトではプレミアム会員登録されません。
          登録を続けますか？
        </div>
        <div className="action-container">
          <div className="button-survey" onClick={approval}>
            登録を続ける
          </div>
          <div className="button-cancel" onClick={reject}>
            閉じる
          </div>
        </div>
        <style jsx>
          {`
            .text-survey {
              margin-top: 24px;
              color: #1b2833;
              text-align: center;
            }
            .action-container {
              display: flex;
              justify-content: center;
              margin: 24px 0;
            }
            .button-cancel {
              width: 96px;
              height: 44px;
              background: #c4c4c4;
              border-radius: 4px;
              display: flex;
              justify-content: center;
              align-items: center;
              flex-direction: column;
              cursor: pointer;
              color: #ffffff;
            }
            .button-survey {
              width: 112px;
              height: 44px;
              background: #31d0aa;
              border-radius: 4px;
              display: flex;
              justify-content: center;
              align-items: center;
              flex-direction: row;
              cursor: pointer;
              color: #ffffff;
              gap: 4px;
              margin-right: 16px;
            }
          `}
        </style>
      </Modal.Body>
    </Modal>
  );
}

export default JapanSiteNoticePremium;
